import type { HTMLChakraProps } from '@chakra-ui/react';
import { ChainId, ChainLayer } from '@cronos-app/sdk';
import type { FC } from 'react';

import { getWcroToken } from './token/registers/wcro';
import { getZkCroToken } from './token/registers/zkcro';

export const ChainIcons: Record<ChainLayer, FC<HTMLChakraProps<'div'>> | null> =
  {
    [ChainLayer.L2]: getZkCroToken(ChainId.CRONOS_ZK_MAINNET).Icon,
    [ChainLayer.CronosEvm]: getWcroToken(ChainId.CRONOS_EVM_MAINNET).Icon,
  };

export const DEX_NAME: Record<ChainLayer, string> = {
  [ChainLayer.CronosEvm]: 'VVS finance',
  [ChainLayer.L2]: 'H2 finance',
};

export const DEX_NAME_SHORT: Record<ChainLayer, string> = {
  [ChainLayer.CronosEvm]: 'VVS',
  [ChainLayer.L2]: 'H2',
};

export const USER_LAYER_TO_INTERNAL: Record<string, ChainLayer | undefined> = {
  cronoszk: ChainLayer.L2,
  cronos: ChainLayer.CronosEvm,
};

export const DEX_LOGO: Record<ChainLayer, string> = {
  [ChainLayer.CronosEvm]: '/tokens/vvs.svg',
  [ChainLayer.L2]: '/images/h2-logo.png',
};

export const INTERNAL_LAYER_TO_USER: Record<ChainLayer, string> = {
  [ChainLayer.L2]: 'cronoszk',
  [ChainLayer.CronosEvm]: 'cronos',
};
